import { getRequest } from '../util/api';

const VERSION1 = '/api/v1/dashboards';

export const getCurrentUser = async (courseId) => {
  const apiHost = window.config.DASHBOARD_API_URL;
  const response = await getRequest(
    `${apiHost}${VERSION1}/courses/${courseId}/user`
  );
  return response;
};
